import moment from "moment";
import { ORDER_STATUS } from "../../../Shared/utils/constants";
import { dateFilters } from "../../constants";
import { OrdersText } from "./Orders-types";
// ********** CONSTS **********
export const itemsPerPage = 10;
// ********** HELPER FUNCTIONS **********
/**
 * Recursively updates the 'Balance' property to 'balance' in the given input
 * object or array of objects.
 *
 * @param {Object|Array} input - The input object or array of objects.
 * @returns {Object|Array} - The input object or array of objects with the
 * 'Balance' property renamed to 'balance'.
 */
export const updateBalancePropertyName = (input) => {
    // Helper function to recursively update the balance property.
    const updateBalance = (obj) => {
        // Check if the input is an array.
        if (Array.isArray(obj)) {
            // If it's an array, recursively call updateBalance on each element.
            return obj.map((item) => updateBalance(item));
        }
        else if (typeof obj === "object" && obj !== null) {
            // If it's an object, recursively call updateBalance on each property.
            const updatedObj = {};
            for (let key in obj) {
                if (key === "Balance") {
                    // Rename 'Balance' to 'balance'.
                    updatedObj["balance"] = obj[key];
                }
                else {
                    // Continue recursively updating other properties.
                    updatedObj[key] = updateBalance(obj[key]);
                }
            }
            return updatedObj;
        }
        else {
            // If it's neither an array nor an object, return the value unchanged.
            return obj;
        }
    };
    // Call the helper function with the input.
    return updateBalance(input);
};
/**
 * On fetch success.
 * @param setError
 * @param setLoadingText
 * @param setCompanyConfig
 * @param dateFilter
 * @param setOrderData
 * @param setPageNumber
 * @returns
 */
export const onSuccess = (setError, setLoadingText, setCompanyConfig, dateFilter, setOrderData, setNumTotalOrders, setPageNumber) => (res) => {
    if (!res.data.success) {
        setLoadingText("");
        setError(`${OrdersText.UNEXPECTED_ERROR} ${OrdersText.ERROR_CODE_OH1}`);
    }
    // TODO: Move this company Provider
    setCompanyConfig({
        companyText: res.data.companyConfig.companyText,
        skipPayments: res.data.companyConfig.skipPayment,
        showPriceIfZero: res.data.companyConfig.showPricesIfZero,
        startSunday: res.data.startSunday,
        deliveryModalPickupDescription: res.data.companyConfig.deliveryModalPickupDescription,
        deliveryModalDeliveryDescription: res.data.companyConfig.deliveryModalDeliveryDescription,
    });
    let orders = res.data.orders;
    if (dateFilter !== dateFilters.upcoming && res.data.orders) {
        orders = res.data.orders.filter((o) => { var _a; return ((_a = o.order) === null || _a === void 0 ? void 0 : _a.OrderStatus) !== ORDER_STATUS.FUTURE; });
    }
    const modifiedOrders = updateBalancePropertyName(orders);
    setOrderData(modifiedOrders);
    setNumTotalOrders(res.data.numTotalOrders || orders.length);
    setLoadingText("");
};
/**
 * On fetch error.
 * @param setError
 * @param setLoadingText
 * @returns
 */
export const onError = (setError, setLoadingText) => (e) => {
    setError(`${OrdersText.UNEXPECTED_ERROR} ${OrdersText.ERROR_CODE_OH1}`);
    setLoadingText("");
};
export const handleDateFilterChange = (setDateFilter, setPageNumber) => (event, child) => {
    const { value } = event.target;
    setDateFilter(Number(value));
    setPageNumber(1);
};
/**
 * Pagination page change.
 * @param setPageNumber
 * @returns
 */
export const handlePageChange = (setPageNumber) => (_, value) => {
    setPageNumber(value);
    window.scrollTo(0, 0);
};
/**
 * Sort orders in chronological order
 * @param dateFilter
 * @param currentOrders
 */
export const sortOrders = (dateFilter, currentOrders) => {
    if (dateFilter === dateFilters.upcoming) {
        currentOrders.sort((a, b) => {
            const aDate = a.order.OrderIsUpcoming ? moment(a.order.ForWeekStartingOn) : moment(a.orderInfo.order_date);
            const bDate = b.order.OrderIsUpcoming ? moment(b.order.ForWeekStartingOn) : moment(b.orderInfo.order_date);
            if (aDate.isBefore(bDate)) {
                return -1;
            }
            else if (aDate.isAfter(bDate)) {
                return 1;
            }
            else {
                return 0;
            }
        });
    }
};
export const dateFilterLoadingText = (dateFilter) => {
    if (dateFilter === dateFilters.upcoming) {
        return OrdersText.LOADING_UPCOMING_ORDERS;
    }
    else if (dateFilter > dateFilters.oneYear) {
        return OrdersText.LOADING_ALL_ORDERS;
    }
    else {
        return `${OrdersText.LOADING_ORDERS_PAST} ${dateFilter} ${OrdersText.MONTHS}`;
    }
};
